import { E_COLUMN_SEARCH_TYPE } from 'src/redux/cases/types/casesTypes';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { convertToDate, E_DATE_TYPE } from 'src/shared/helpers/dateHelpers';
export var parseUsers = function (users, columns, i18n) {
    return users.map(function (user, index) {
        var valueParsed = columns.map(function (col) {
            var keyMapForValue = col.keyMapForValue, type = col.type, style = col.style;
            var text = null;
            keyMapForValue.forEach(function (key) {
                var indexOfFirstSep = key.source.indexOf('.');
                var subKey = key.source.substring(indexOfFirstSep + 1);
                var valueFind = getPropsByKeyPath(user, subKey);
                if (valueFind) {
                    if (key.translation && i18n) {
                        var translatedValue = getPropsByKeyPath(i18n.keyValueMap, key.translation.substring(3, key.translation.length - 2).replace('$source', valueFind));
                        text = text ? "".concat(text, " ").concat(translatedValue) : translatedValue;
                    }
                    else {
                        text = text ? "".concat(text, " ").concat(valueFind) : valueFind;
                    }
                }
            });
            switch (type) {
                case E_COLUMN_SEARCH_TYPE.DATE: {
                    return {
                        text: convertToDate(E_DATE_TYPE.DATE, text),
                        style: style,
                    };
                }
                case E_COLUMN_SEARCH_TYPE.TIME_LEFT: {
                    return {
                        text: convertToDate(E_DATE_TYPE.SINCE, text),
                        style: style,
                    };
                }
                default: {
                    return {
                        text: text,
                        style: style,
                    };
                }
            }
        });
        return {
            id: user.keycloakId,
            email: user.email,
            isLocked: !user.enabled,
            values: valueParsed,
        };
    });
};
